export const storeToken = (token: string | null) => {
  if (!token) {
    localStorage.removeItem("andytown__token2");
  } else {
    localStorage.setItem("andytown__token2", token);
  }
};
